import * as React from 'react';

import { useAiPoweredSearchExperiment } from 'bundles/search-common/providers/AiPoweredSearchExperimentProvider';
import { CoachStateProvider } from 'bundles/unified-common/providers/CoachStateProvider';
import { TwoPanelChatRouteProvider } from 'bundles/unified-common/providers/TwoPanelChatRouteProvider';

// Lazy-loaded to avoid pulling in CoachChat → SSELink → ApolloLink at module-load
// time, which breaks unrelated test suites that transitively import this provider.
const CoachChatContainer = React.lazy(
  () => import('bundles/search-common/components/experiments/aiSearchOnLohp/CoachChatContainer')
);

function SearchCoachProvider({ children }: React.PropsWithChildren) {
  const { enableConversationalSearch } = useAiPoweredSearchExperiment();

  return (
    <CoachStateProvider coachOpen={enableConversationalSearch}>
      {enableConversationalSearch ? (
        <TwoPanelChatRouteProvider>{children}</TwoPanelChatRouteProvider>
      ) : (
        <>
          {children}
          <React.Suspense fallback={null}>
            <CoachChatContainer />
          </React.Suspense>
        </>
      )}
    </CoachStateProvider>
  );
}

export default SearchCoachProvider;
